export const SET_MASTER_COURSE_FILTER = 'SET_MASTER_COURSE_FILTER'
export const SET_UNREAD_NOTIFICATIONS_COUNT = 'SET_UNREAD_NOTIFICATIONS_COUNT'

export const setMasterCourseFilter = masterCourseId => ({
  type: SET_MASTER_COURSE_FILTER,
  payload: {
    masterCourseId
  }
})

export const setUnreadNotificationsCount = count => ({
  type: SET_UNREAD_NOTIFICATIONS_COUNT,
  payload: {
    count
  }
})
